import { useQuery } from "@tanstack/react-query";
import type { StrandLoss } from "../../../../../controls/ganttAsset/types/strand-loss";
import type { Process, ProcessEvent } from "../../../models/ProcessGanttChart";
import { getGanttData } from "../../../repositories/ProductionRepository";

interface GanttQueryData {
  processes: Process[];
  processEvents: ProcessEvent[];
  strandLosses: StrandLoss[];
}

export const useDashboardGanttQuery = (
  startDate: Date | null,
  endDate: Date | null,
) => {
  return useQuery({
    queryKey: [
      "dashboard-gantt",
      startDate?.toISOString(),
      endDate?.toISOString(),
    ],
    meta: { realtime: ["RBD.GetGanttData"] },
    queryFn: async ({ signal }): Promise<GanttQueryData> => {
      const resp = await getGanttData(startDate, endDate, signal);
      if (resp.ok) {
        return {
          processes: resp.data?.tables?.[0]?.rows ?? [],
          processEvents: resp.data?.tables?.[1]?.rows ?? [],
          strandLosses: resp.strandLosses,
        };
      }
      throw new Error(resp.message ?? "Failed to fetch gantt data");
    },
    enabled: !!startDate && !!endDate,
  });
};
